import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { faFolderOpen, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import m from '../messages';

export default function TableCategory({ description, items, links }) {
  const renderTableTitle = () => description
    ? <h3 className='table__title'>{<FormattedMessage {...m.categoriesTableTitle} values={{ description }}/>}</h3>
    : null;

  const renderTableHead = () => (
    <div className='table__row table__row--header'>
      <div className='table__col'><FormattedMessage {...m.categoryTableHeader} /></div>
      <div className='table__col'><FormattedMessage {...m.subCategoriesTableHeader} /></div>
      <div className='table__col'><FormattedMessage {...m.boardsTableHeader} /></div>
    </div>
  )

  const renderTableBody = () => items.map(rowItem => (
    <div className='table__row' key={rowItem.path}>
      <div className='table__col'>
        <Link className='table__link' to={rowItem.path}>
          <span className='table__image'>
            <FontAwesomeIcon icon={faFolderOpen} />
          </span>
          {rowItem.title}
        </Link>
      </div>
      <div className='table__col'>{rowItem.subCategories}</div>
      <div className='table__col'>{rowItem.boards}</div>
    </div>
  ))


  const renderLinksMore = ({ title, path }) => (
    <div className='table__more'>
      <Link className='table__more-link' to={path}>
        {<FormattedMessage {...m.moreCategoryLink} values={{ title }}/>}
      </Link>
    </div>
  )


  return (
    <div className='table table--category'>
      <div className='table__body'>
        { renderTableTitle() }
        { renderTableHead() }
        { renderTableBody() }
      </div>
      { links && renderLinksMore(links[0]) } 
    </div>
  )
}


TableCategory.propTypes = {
  description: PropTypes.string,
  items: PropTypes.array,
  links: PropTypes.arrayOf(PropTypes.object), // array of one element
}